
$(function() {
    $('a[data-modal-link]').on('click', function (e) {

        e.preventDefault();
        const $self = $(this);

        $.ajax({
            url: $self.attr('href'),
            type: 'GET',
            cache: false,
            beforeSend: function (request) {
                request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
            },
            success: function(html) {

                $('#modalLinkContent').remove();

                const modalHtml = ModalTemplateHtml
                    .replace('{{MODAL_CONTENT}}', html)
                    .replace('{{MODAL_CSS_CLASS}}', $self.data('modal-css-class') ?? 'link-content');

                $('body').append(modalHtml);

                $('#modalLinkContent').modal();

                var $source = $('#modalLinkContent .language-popup h2:first');
                var $destination = $('#modalLinkContent .modal-header');

                $source.prependTo($destination);
            }
        });
    });
});

var ModalTemplateHtml =
    '<div id="modalLinkContent" class="modal {{MODAL_CSS_CLASS}}" tabindex="-1" role="dialog">' +
        '<div class="modal-dialog modal-lg" role="document">' +
            '<div class="modal-content">' +
                '<div class="modal-header">' +
                    '<button type="button" class="close" data-dismiss="modal" aria-label="Close">' +
                        '<span aria-hidden="true">&times;</span>' +
                    '</button>' +
                '</div>' +
                '<div class="modal-body">' +
                    '{{MODAL_CONTENT}}' +
                '</div>' +
            '</div>' +
        '</div>' +
    '</div>';
